import { useSelector } from "react-redux";

import { Error } from "@livechat/design-system-icons";
import { Icon, SpacingToken, Text } from "@livechat/design-system-react-components";

import { EmptyState } from "components/empty-state/EmptyState";
import Block from "components/layout/Block";
import Flex from "components/layout/Flex";
import { selectAdmins } from "store/entities/agents";
import { withVar } from "themes/helpers";
import { plural } from "utils/string";

export const SubscriptionExpired: React.FC = () => {
  const admins = useSelector(selectAdmins);

  return (
    <Flex alignItems="center" justifyContent="center" height="100%">
      <EmptyState title="Your HelpDesk subscription has expired" icon={<Icon source={Error} size="xxxlarge" />}>
        <Text>
          You&apos;re not allowed to manage the subscription.
          <br />
          Contact {plural(admins.length, "the Admin", "one of the Admins")} to do so:
        </Text>
        <Block marginTop={withVar(SpacingToken.Spacing3)}>
          {/* TODO: Fix this the next time the file is edited. */}
          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
          {admins.map((admin: any) => (
            <Text key={admin.id}>
              <b>{admin.name}</b> ({admin.email})
            </Text>
          ))}
        </Block>
      </EmptyState>
    </Flex>
  );
};
